import React from 'react';
// import { useLocation } from 'react-router-dom'
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Logo from './Logo';
import NavItem from './NavItem';
import LastItem from './LastItem';
import useMdUpScreen from '../../hooks/useMdUpScreen';
import { useThemeCustomStyles } from '../../hooks/useThemeConfig';

export default function NavigationAppBar() {
  //const location = useLocation();
  //console.log('location', location.pathname);
  const navItems = [
    {
      path: '/',
      local: true,
      text:  'Home',
    },
    {
      path: '/login',
      local: true,
      text:  'Login',
    },
  ];
  const styles = useThemeCustomStyles();

  const mdUpScreen = useMdUpScreen();
  
  const logoSx = styles.Navbar.Logo(mdUpScreen); 
  const toolbarSx = styles.Navbar.Toolbar(mdUpScreen);
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar>
        <Toolbar disableGutters sx={toolbarSx}>
          <Logo sx={logoSx}/>
          <Box
            sx={{
              flexGrow: 1,
            }}
          />
          {navItems.map((navItem) => <NavItem path={navItem.path} text={navItem.text} local={navItem.local} navItemStyle={styles.Navbar.NavItem}/>)}
          <LastItem mdUpScreen={mdUpScreen} config={styles.Navbar.LastItem} />
        </Toolbar>
      </AppBar>
    </Box>
  );
}